import { render } from "./RmaTasks.vue?vue&type=template&id=6134be1b&scoped=true&ts=true&lang=pug"
import script from "./RmaTasks.vue?vue&type=script&lang=ts"
export * from "./RmaTasks.vue?vue&type=script&lang=ts"

import "./RmaTasks.vue?vue&type=style&index=0&id=6134be1b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6134be1b"]])

export default __exports__